import React from "react";
import { Grid, Link, Typography } from "@material-ui/core";
import AlertBox from "../../../../../components/AlertBox/AlertBox";
import {
  WEEBHOOKS_TERMS_AND_CONDITIONS,
  WEBHOOKS_TERMS_AND_CONDITIONS_URL,
  FOR_DETAILS,
  CLICK_HERE,
} from "../../../../../constants/strings";

const WebhookTermsAndConditions = () => (
  <Grid item xs={12}>
    <AlertBox
      variant="warning"
      subtitle={
        <Typography variant="body3" style={{ color: "black" }}>
          {WEEBHOOKS_TERMS_AND_CONDITIONS}{" "}
          <Link
            href={WEBHOOKS_TERMS_AND_CONDITIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", textDecoration: "underline" }}
          >
            {CLICK_HERE}
          </Link>{" "}
          {FOR_DETAILS}
        </Typography>
      }
    />
  </Grid>
);

export default WebhookTermsAndConditions;
